import { TableCell, TableCellProps } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import { HeaderCellVariant } from '../types/HeaderCellVariant'
import HeaderEnding from './HeaderEnding'

interface OverrideProps {
  variant: HeaderCellVariant
  isLast?: boolean
  isFirst?: boolean
}

type VariantMapping = Partial<Record<HeaderCellVariant, string>>

interface DateCellProps extends Omit<TableCellProps, 'variant'> {
  variant: HeaderCellVariant
  isLast?: boolean
  isFirst?: boolean
}

const getStyleByVariantProp = (mapping: VariantMapping) => (props: OverrideProps) => mapping[props.variant]

const useStyles = makeStyles<Theme, OverrideProps>((theme) =>
  createStyles({
    root: {
      position: 'relative',
      borderBottom: 'none',
      height: 46,
      padding: getStyleByVariantProp({
        salary: '8px 0 0',
        revenue: '0 0 0 8px',
      }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(theme.typography.lato.captionBold as any),
      textAlign: 'center',
      color: '#757575',
      backgroundColor: getStyleByVariantProp({
        salary: '#E3EFF5',
        revenue: '#EDF8F7',
      }),
    },
    innerCont: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      height: 48,
      minWidth: ({ variant }) => {
        return variant === 'salary' ? 92 : 55
      },
      padding: getStyleByVariantProp({
        salary: '0',
        revenue: '0 16px',
      }),
      borderTopRightRadius: ({ variant, isLast, isFirst }) => {
        if ((isLast && variant === 'salary') || (isFirst && variant === 'revenue')) return 8

        return 0
      },
      borderBottomRightRadius: ({ isLast }) => {
        if (isLast) return 8

        return 0
      },
      borderBottomLeftRadius: ({ variant, isLast, isFirst }) => {
        if ((isLast && variant === 'revenue') || (isFirst && variant === 'salary')) return 8

        return 0
      },
      borderTopLeftRadius: ({ isFirst }) => {
        if (isFirst) return 8

        return 0
      },
    },
  })
)

const DateCell = ({ variant, isLast, isFirst, children, ...other }: DateCellProps) => {
  const classes = useStyles({ variant, isLast, isFirst })

  return (
    <TableCell className={classes.root} {...other}>
      <div className={classes.innerCont}>{children}</div>
      {isLast && <HeaderEnding variant={variant} cellType="date" />}
    </TableCell>
  )
}

export default DateCell
